import { buildTranslate } from 'locales'
import moment from 'moment-timezone'
import { SyncRowLabels } from './SyncRow'

const t = buildTranslate('cms.settings.revenue_centers')

export const buildSyncRowLabels = (
  providerName: string,
  syncedAt?: string | null
): SyncRowLabels => ({
  synced: syncedAt
    ? t('sync.synced', {
        provider: providerName,
        time: moment(syncedAt).fromNow(),
      })
    : '',
  never: t('sync.never', { provider: providerName }),
  auto: t('sync.auto'),
  syncNow: t('sync.sync_now'),
})
